import { StaticJsonRpcProvider } from '@ethersproject/providers'
import {
  GRX_CHAIN_ID,
  SupportedChainId,
  isSupportedChainId,
} from 'config/constants/chains'
import { getRpcUrlByChain } from 'utils/getRpcUrl'

const providerCache: Partial<
  Record<SupportedChainId, StaticJsonRpcProvider>
> = {}

export const getRpcProvider = (
  chainId?: number,
): StaticJsonRpcProvider => {
  const selectedChainId: SupportedChainId = isSupportedChainId(chainId)
    ? chainId
    : GRX_CHAIN_ID

  if (!providerCache[selectedChainId]) {
    providerCache[selectedChainId] = new StaticJsonRpcProvider(
      getRpcUrlByChain(selectedChainId),
      selectedChainId,
    )
  }

  return providerCache[selectedChainId] as StaticJsonRpcProvider
}

// Legacy GRX provider for old GRX-only modules.
export const simpleRpcProvider = getRpcProvider(GRX_CHAIN_ID)

export default null
